import { Heading, Paragraph } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurShadow,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

type WrapperProps = {
    $variant: 'minimal' | 'full';
};

export const ServiceCardTitleSection = styled.div`
    display: flex;
    margin-bottom: ${getPurpurSpacing('200')};
    flex-shrink: 0;
`;

export const ServiceCardIcon = styled(Icon)`
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
`;

export const ServiceCardTitle = styled(Heading)`
    font-weight: ${getPurpurTypography('weightBold')};
`;

export const ServiceCardDescriptionContainer = styled.div`
    flex: 1;
`;

export const ServiceCardDescription = styled(Paragraph).attrs({ variant: 'paragraph-100' })`
    max-height: 3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const ServiceCardCta = styled.div`
    display: flex;
    align-items: center;
    padding: ${getPurpurSpacing('150')} 0;
    gap: ${getPurpurSpacing('100')};
    color: ${getPurpurColor('textInteractivePrimary')};
    margin-top: ${getPurpurSpacing('100')};
    font-weight: ${getPurpurTypography('weightMedium')};
    line-height: ${getPurpurTypography('lineHeightTight')};
    flex-shrink: 0;
    ${purpurMedia('md')`
        margin-top: ${getPurpurSpacing('200')};
    `};
`;

export const ServiceCardWrapper = styled.a<WrapperProps>`
    display: flex;
    flex-direction: column;
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray300')};
    border-radius: ${getPurpurBorder('radiusMd')};
    background: ${getPurpurColor('functionalWhite')};
    padding: ${({ $variant }) => ($variant === 'full' ? getPurpurSpacing('300') : getPurpurSpacing('200'))};
    box-shadow: ${getPurpurShadow('md')};
    height: 100%;
    padding-top: ${getPurpurSpacing('300')};
    padding-bottom: ${({ $variant }) => ($variant === 'full' ? getPurpurSpacing('200') : getPurpurSpacing('300'))};
    padding-left: ${({ $variant }) => ($variant === 'full' ? getPurpurSpacing('300') : getPurpurSpacing('200'))};
    padding-right: ${({ $variant }) => ($variant === 'full' ? getPurpurSpacing('300') : getPurpurSpacing('200'))};
    ${({ $variant }) =>
        $variant === 'full' &&
        purpurMedia('md')`
            padding: ${getPurpurSpacing('300')};
        `};
    ${({ $variant }) =>
        $variant !== 'full' &&
        purpurMedia('md')`
            padding: ${getPurpurSpacing('200')};
        `};
    &,
    &:hover,
    &:focus {
        color: ${getPurpurColor('textDefault')};
        text-decoration: none;
    }
    ${purpurFocus()};
    ${ServiceCardTitleSection} {
        flex-direction: row;
        align-items: center;
        gap: ${getPurpurSpacing('100')};
        ${({ $variant }) =>
            $variant === 'full' &&
            purpurMedia('md')`
                flex-direction: column;
                align-items: flex-start;
                gap: ${getPurpurSpacing('200')};
            `};
        ${({ $variant }) =>
            $variant !== 'full' &&
            purpurMedia('md')`
                flex-direction: row;
                gap: ${getPurpurSpacing('100')};
            `};
    }
    ${ServiceCardIcon} {
        ${({ $variant }) =>
            $variant === 'full' &&
            purpurMedia('md')`
                width: 2rem;
                height: 2rem;
            `};
    }
`;
